import { Reveal } from "@/lib/reveal";
import waterImage from "@/assets/april-dive-wide.jpg";

export function Transition() {
  return (
    <section aria-label="Photographic interlude" data-testid="bw-transition">
      <Reveal>
        <figure className="film-frame">
          <img
            src={waterImage}
            alt="Maya, a character in The Inkwell's film At Last, diving through a column of turquoise light beneath the surface of a pool, face turned toward the light"
            loading="lazy"
            width={1672}
            height={941}
            className="photo-wash h-[52vh] min-h-[360px] w-full object-cover object-center md:h-[64vh]"
          />
        </figure>
      </Reveal>
    </section>
  );
}
